import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './ResultsEmpty.css';
import { EDeviceType } from '../../types/device';

export interface IResultsEmptyStoreProps {
  deviceType: EDeviceType;
  onClick(): void;
}

export const ResultsEmptyForAuthorization: React.FC<IResultsEmptyStoreProps> = props => {
  const { deviceType, onClick } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['empty-background']} />
        <div className={styles['title']}>
          <span>Войдите, чтобы увидеть объявления</span>
        </div>
        <Button size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'} theme="fill_primary" onClick={onClick}>
          Вход или регистрация
        </Button>
      </div>
    </div>
  );
};
